import React from 'react';
import { Container, Typography, Box, Button, Paper } from '@mui/material';
import ConstructionIcon from '@mui/icons-material/Construction';
import { useNavigate } from 'react-router-dom';

const UnderConstructionPage: React.FC = () => {
  const navigate = useNavigate();

  const handleLoginClick = () => {
    navigate('/admin');
  };

  return (
    <Container maxWidth="sm">
      <Paper elevation={3} sx={{ mt: 8, p: 4, textAlign: 'center' }}>
        <ConstructionIcon color="primary" sx={{ fontSize: 64, mb: 2 }} />
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          Website Under Construction
        </Typography>
        <Typography variant="body1" color="textSecondary" sx={{ mb: 4 }}>
          We're currently working on this site. Please check back soon!
        </Typography>
        <Button variant="contained" color="primary" onClick={handleLoginClick}>
          Admin Login
        </Button>
      </Paper>

      <Box mt={4} textAlign="center">
        <Typography variant="caption" color="textSecondary">
          Powered by Scheduify
        </Typography>
      </Box>
    </Container>
  );
};

export default UnderConstructionPage;
